export const EMPLOYER = "Employer";
export const JOB_SEEKER = "Jobseeker";
export const FREELANCER = "Freelancer";
export const PLACEHOLDER_TXT = "your active Email ID / Username";
export const SUCCESSFUL = "Successful";
export const REJECTED = "Rejected";
